/**
 * @module ol-ishare/string
 */

const templateRe = /\$\{ *([\w_ -]+) *\}/g;

/**
 * Simple templating facility, accepts a template string of the form `'Hello ${a}, ${b}'`
 * and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
 * `'Hello foo, bar'`. You can also specify functions instead of strings for
 * data values — they will be evaluated passing `data` as an argument.
 * @param {String} str String with template placeholders
 * @param {Object} data Object with properties corrisponding with placeholders
 * @param {Boolean} strict When `true` throw an Error when `str` contains a
 *                         placeholder for which there is no corresponding property
 *                         in `data`. Defaults to `false`.
 * @returns {String} `str` with placeholders replaced with values from `data`
 */
function template(str, data, strict = false) {
  return str.replace(templateRe, (str, key) => {
    let value = data[key];
    if (value === undefined && strict) {
      throw new Error(`No value provided for variable ${str}`);
    } else if (typeof value === 'function') {
      value = value(data);
    }
    return value ?? '';
  });
}

export { template };
